import axios from 'axios';
import { token } from '../../../services/Apis';
import { juegosDeportivosApi } from '../../sistema/deportes/DeportesService';

export const TORNEOS_CONST = 'torneos';

export const allTorneosService = async (params) => {
  const res = await axios.get(`${juegosDeportivosApi}/${TORNEOS_CONST}`, {
    headers: token({}),
    params,
  });
  return res;
};

export const saveTorneosService = async (id, data) => {
  let res;
  if (id) {
    res = await axios.patch(
      `${juegosDeportivosApi}/${TORNEOS_CONST}/${id}`,
      data,
      {
        headers: token({}),
      },
    );
  } else {
    res = await axios.post(`${juegosDeportivosApi}/${TORNEOS_CONST}`, data, {
      headers: token({}),
    });
  }
  return res;
};

export const oneTorneosService = async (id) => {
  const res = await axios.get(`${juegosDeportivosApi}/${TORNEOS_CONST}/${id}`, {
    headers: token({}),
  });
  return res;
};

export const deleteTorneosService = async (id) => {
  const res = await axios.delete(
    `${juegosDeportivosApi}/${TORNEOS_CONST}/${id}`,
    {
      headers: token({}),
    },
  );
  return res;
};
